import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client'
import {
  GetTheatricalUserPreferencesQuery,
  GetTheatricalUserPreferencesQueryVariables,
} from '@/types/codegen-federation'

export const GET_THEATRICAL_USER_PREFERENCES = gql`
  query GetTheatricalUserPreferences {
    theatricalUserPreferences {
      id
      autobookEnabled
      optInStatus
      timezone
      phoneNumber
      theaterPreferences {
        id
        priority
      }
      dayPreferences {
        day
        timeRanges {
          start
          end
        }
      }
      preferredVenues {
        id
        name
        providerId
        vendorLogo {
          cloudinaryPath
        }
        phone
        addressText
        address {
          line
          city
          countryCode
          zipCode
        }
      }
    }
  }
`

export const getTheatricalUserPreferences = async (client: ApolloClient<NormalizedCacheObject>) => {
  const { data } = await client.query<GetTheatricalUserPreferencesQuery, GetTheatricalUserPreferencesQueryVariables>({
    query: GET_THEATRICAL_USER_PREFERENCES,
  })
  return data?.theatricalUserPreferences
}
